import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL + "/DistributionChannel";

export const getDistributionChannelList = () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res.data;
  });
};

//Add DistributionChannel
export const addDistributionChannel = async (newData) => {
  return await axios.post(`${api_base_url}`, newData[0]);
};

//Delete DistributionChannel
export const deleteDistributionChannel = async (ids) => {
  await axios.delete(`${api_base_url}`, {
    data: ids,
  });
};

//Update DistributionChannel
export const updateDistributionChannel = async (updatedDistributionChannel) => {
  return await axios.put(`${api_base_url}`, {
    ...updatedDistributionChannel,
  });
};
